import { captureException, withScope } from '@sentry/browser';
import { ApiRedirectCausedRejection } from 'utils/network';
// NOTE: You can't re-throw error in catch handler
// Throwing inside a .catch continues the chain with a rejected promise,
// and you have no more catches, leading to an unterminated chain, which swallows errors

export default (e, captureContext = null) => {
  // If error was caused by rejecting a request because of API Redirect, it's not really an error.
  if (e instanceof ApiRedirectCausedRejection) {
    return;
  }

  withScope(scope => {
    scope.setTag('RAVEN_VERSION', process.env.RAVEN_VERSION || 'VERSION-NOT-DEFINED');
    if (e instanceof Error) {
      scope.setFingerprint(['{{ type }}']);
      scope.setLevel('error');
      scope.setExtra('Handler', 'Raven Error Handler');

      if (captureContext) {
        captureException(e, captureContext);
      } else {
        captureException(e);
      }
    }
  });
};
